import { createApp } from 'vue'
import App from './App.vue'
import { Vue3Editor } from "vue3-editor";
import router from './router'
import axios from 'axios';
import store from './store'
import VueDatePicker from '@vuepic/vue-datepicker';
import vuetify from './plugins/vuetify'
// import Cropper from 'cropperjs';
import { loadFonts } from './plugins/webfontloader'

import VueElementLoading from "vue-element-loading";


loadFonts()
const app = createApp(App);
app.component("Vue3Editor", Vue3Editor);
app.component('VueDatePicker', VueDatePicker);
app.component("VueElementLoading", VueElementLoading);

// axios.defaults.baseURL = 'http://192.168.36.45:5059';
// app.config.globalProperties.baseURL = "http://192.168.36.45:5059";
// app.config.globalProperties.mediaURL = "http://192.168.36.45:5059/file/get/"

// axios.defaults.baseURL = 'https://f4020lwv-5059.inc1.devtunnels.ms/';
// app.config.globalProperties.baseURL = "https://f4020lwv-5059.inc1.devtunnels.ms/";
// app.config.globalProperties.mediaURL = "https://f4020lwv-5059.inc1.devtunnels.ms/file/get/"

axios.defaults.baseURL = 'https://api.salemmtc.org';
app.config.globalProperties.baseURL = "https://api.salemmtc.org";
app.config.globalProperties.mediaURL = "https://api.salemmtc.org/file/get/"

//     app.config.globalProperties.mediaURLs = "api.salemmtc.org/wp?key="


    







createApp(App)
    .use(router)
    .use(store)
    .use(vuetify)
    // .use(Cropper)
    .mount('#app')